import { render, staticRenderFns } from "./verificationDetails.vue?vue&type=template&id=34b9b2a0&scoped=true"
import script from "./verificationDetails.vue?vue&type=script&lang=js"
export * from "./verificationDetails.vue?vue&type=script&lang=js"
import style0 from "./verificationDetails.vue?vue&type=style&index=0&id=34b9b2a0&prod&lang=css"
import style1 from "./verificationDetails.vue?vue&type=style&index=1&id=34b9b2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b9b2a0",
  null
  
)

export default component.exports